module.exports = __webpack_public_path__ + "img/country-6.0fee486a.jpg";